import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import {
    SubChartType,
    STBarGrouping,
    STBarDir,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { PresetChartType } from '../chart-presets/const';
import type { IBarChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class BarChart extends BaseSubChart implements IBarChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.BarChart, uiData, sdkData, rawUiData);
    }
    public type = SubChartType.BarChart;
    /**
     * 系列重叠
     * 取值 -100 ~ 100
     */
    public overlap?: number;
    /**
     * 间隙宽度
     * 取值0 ~ 500
     */
    public gapWidth?: number;
    /**
     * 柱形图方向
     */
    public direction?: STBarDir;
    /**
     * 柱形图分组类型
     */
    public grouping?: STBarGrouping;

    public getPresetChartType(): PresetChartType {
        if (this.direction === STBarDir.col) {
            switch (this.grouping) {
                case STBarGrouping.clustered:
                    return PresetChartType.COLUMN_CLUSTERED;
                case STBarGrouping.stacked:
                    return PresetChartType.COLUMN_STACKED;
                case STBarGrouping.percentStacked:
                    return PresetChartType.COLUMN_PERCENT_STACKED;
                default:
                    return PresetChartType.COLUMN_CLUSTERED;
            }
        } else {
            switch (this.grouping) {
                case STBarGrouping.clustered:
                    return PresetChartType.BAR_CLUSTERED;
                case STBarGrouping.stacked:
                    return PresetChartType.BAR_STACKED;
                case STBarGrouping.percentStacked:
                    return PresetChartType.BAR_PERCENT_STACKED;
                default:
                    return PresetChartType.BAR_CLUSTERED;
            }
        }
    }
}
